<template lang="pug">
.front-landing-page
  md-header(:icon="item.icon" :key="headerRefresh")
  .content.front
    .box-banner
      .container
        .col-md-12
          carousel.box-owl-carousel(:items="1" :loop="true" :autoHeight="true" :autoplay="true" :lazyLoad="true" :dots="true"  :center="true" :nav="false" v-if="item.banner && item.banner !== null && item.banner.length > 0")
            img.item-banner(v-for="(banner, index) in item.banner" :src="banner" v-if="banner.length > 0")
    .box-pc
      .container
        .col-md-12
          .title-pc(v-if="item !== null && item.name !== undefined && item.name.length > 0") {{item.name}}
          .item-pc-info(ref="boxInfo" :style="stylesMaxHeight")
            .description(v-html="item.description")
            .gradient(v-if="isMore")
            a.view-more(v-if="isMore" @click="showMore") {{this.$t('home.view_more')}} >>
          .item-pc-teacher(ref="boxTeacher" v-if="item.user_public")
            .avatar
              img(v-if="item.user_public && item.user_public.avatar !== undefined && item.user_public.avatar !== null && item.user_public.avatar.length > 0" :src="item.user_public.avatar")
              img(src="../../../assets/images/home/swarm.svg" v-else)
            .teacher-type {{this.$t('landing.teacher')}}:
            .teacher-name(v-if="item.user_public && item.user_public.fullname !== undefined") {{item.user_public.fullname}}
            .teacher-about(v-if="item.user_public && item.user_public.userquotes !== undefined" v-html="item.user_public.userquotes")
            button.button.active(@click="publicTeacher(item.user_public)") {{this.$t('landing.teacher_view')}}
            button.button(@click="chatBox") {{this.$t('landing.teacher_chat')}}
    .box-pc-classes(v-if="item.classes && item.classes !== null && item.classes.length > 0")
      .container
        .col-md-12
          #toClasses.row.custom-classes
            div(v-for="(classes) in item.classes")
              ItemClasses(:pcID="item.id" :item="classes" v-if="!item.private")
      .container(v-if="item.user_public && item.user_public.id !== undefined && item.user_public.id !== null && item.user_public.id.length > 0")
        .col-md-12
          FrontCourse(:teacherID="item.user_public.id" :item="item")
      .container(v-if="item.user_public && item.user_public.id !== undefined && item.user_public.id !== null && item.user_public.id.length > 0")
        .col-md-12
          FrontExercise(:teacherID="item.user_public.id" :item="item" :pcInfo="pcInfo")
      .container(v-if="item.user_public && item.user_public.id !== undefined && item.user_public.id !== null && item.user_public.id.length > 0")
        .col-md-12
          FrontVideo(:teacherID="item.user_public.id" :item="item" :pcInfo="pcInfo")
      .container(v-if="item.user_public && item.user_public.id !== undefined && item.user_public.id !== null && item.user_public.id.length > 0")
        .col-md-12
          FrontLesson(:teacherID="item.user_public.id" :item="item" :pcInfo="pcInfo")
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../Model/graphqlfront'
import MdNotification from '@/core/components/mdNotification'
import store from '../../../store'
import MdHeader from '@/components/Front/LandingPage/landing'
import carousel from 'vue-owl-carousel'
import ItemClasses from '@/components/Front/LandingPage/itemClasses'
import FrontLesson from '@/components/Front/LandingPage/Lesson'
import FrontVideo from '@/components/Front/LandingPage/Video'
import FrontCourse from '@/components/Front/LandingPage/Course'
import FrontExercise from '@/components/Front/LandingPage/Exercise'

export default {
  components: {
    MdNotification,
    MdHeader,
    store,
    carousel,
    ItemClasses,
    FrontLesson,
    FrontVideo,
    FrontCourse,
    FrontExercise
  },
  data() {
    return {
      item: [],
      message: this.$t('home.comming_soon'),
      isMore: false,
      isResize: false,
      pcInfo: [],
      headerRefresh: 0
    }
  },
  computed: {
    stylesMaxHeight () {
      if (this.isMore && !this.isResize) {
        return {
          'max-height': `${this.heightTeacher()}px`,
          'overflow': 'hidden'
        }
      } else {
        return {
          'max-height': 'inherit',
          'overflow': 'auto'
        }
      }
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    refreshHeader() {
      this.headerRefresh++
    },
    heightTeacher () {
      if (this.$refs.boxTeacher !== undefined) {
        return this.$refs.boxTeacher.clientHeight
      }
    },
    heightInfo () {
      if (this.$refs.boxInfo !== undefined) {
        return this.$refs.boxInfo.clientHeight
      }
    },
    async checkPCExists(id) {
      if (id > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_PC_LANDING_PAGE),
          fetchPolicy: 'no-cache',
          variables: {
            where: {id: {_eq: id}},
            whereTwo: {pc_id: {_eq: id}, private: {_eq: false}}
          }
        })
        if (data.private_community && data.private_community.length > 0) {
          return data.private_community[0]
        }
      }
      return false
    },
    async historyStudent () {
      // neu da dang nhap
      if (this.item && this.item.id !== undefined && this.$store.getters.user) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_USER_PUBLIC),
          fetchPolicy: 'no-cache',
          variables: {
            uid: this.$store.getters.user
          }
        })
        if (data && data.v_user_public && data.v_user_public !== null && data.v_user_public.length > 0) {
          // neu la tai khoan hoc sinh
          if (data.v_user_public[0].type_user === 1) {
            this.createHistoryPC(this.item.id, this.$store.getters.user, 'IN', 'Tài khoản đang vào PC ' + this.item.name)
          }
        }
      }
    },
    publicTeacher(item) {
      if (item.id !== undefined) {
        this.$router.push({name: 'account-view', params: {uid: item.id}})
      }
    },
    chatBox() {
      this.showNotification(this.message, 'warning', 'top', 'right', 7000)
    },
    showMore() {
      this.isMore = false
    },
    isMobile() {
      if (window.innerWidth < 667) return true
      return false
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    eventHandler() {
      this.isMore = false
      this.isResize = true
      setTimeout(() => {
        if (this.heightInfo() > this.heightTeacher()) {
          this.isMore = true
          this.isResize = false
        }
      }, 200)
    },
    async getInfoAllPC (pcID) {
      this.item = await this.checkPCExists(pcID)
      await this.historyStudent()
      if (this.item === false || this.item === null) {
        this.$router.push({path: '/'})
      }
    },
    addMinutes(dt, minutes) {
      var now = new Date(dt.getTime() + minutes * 60000)
      return (now.getFullYear() + '-' + (((now.getMonth() + 1) < 10) ? ('0' + (now.getMonth() + 1)) : ((now.getMonth() + 1))) + '-' + (now.getDate()) + ' ' + now.getHours() + ':' + ((now.getMinutes() < 10) ? ('0' + now.getMinutes()) : (now.getMinutes())) + ':' + ((now.getSeconds() < 10) ? ('0' + now.getSeconds()) : (now.getSeconds())))
    },
    async createHistoryPC(pcID, userID, action, description) {
      var objInput = {
        pc_id: pcID,
        user_id: userID,
        action: action,
        name: 'STUDENT',
        description: description,
        access_time: this.addMinutes(new Date(), 10)
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.CREATE_PC_HISTORY),
        variables: {objInput: objInput}
      })
    },
    async getInfoPC(id) {
      if (id > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_PC_WHERE_ANY),
          fetchPolicy: 'no-cache',
          variables: {
            where: {id: {_eq: id}}
          }
        })
        if (data.private_community && data.private_community.length > 0) {
          this.pcInfo = data.private_community[0]
          await this.getInfoAllPC(this.pcInfo.id)
        }
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.params.front_top !== undefined && this.$route.params.front_top) {
        window.scrollTo(0, this.$route.params.front_top)
      }
      if (!this.isMobile()) {
        this.isMore = false
        if (this.heightInfo() > this.heightTeacher()) {
          this.isMore = true
        }
      }
      if (this.$route.hash !== null) {
        this.$mycontroller.scrollViewToElement(this.$route.hash)
      }
    }, 100)
    this.refreshHeader()
  },
  async created () {
    window.addEventListener('resize', this.eventHandler)
    if (this.$route.params && this.$route.params !== null && this.$route.params.id !== undefined && !isNaN(this.$route.params.id) && Number(this.$route.params.id) > 0) {
      var pcID = this.$route.params.id
      try {
        await this.getInfoPC(pcID)
      } catch (error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      }
    } else {
      this.$router.push({path: '/'})
    }
    this.eventHandler()
  },
  watch: {
    route: function() {
    }
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.front-landing-page{
  .content{
    &.front{ background: #FFFFFF;
      .box-banner{ background: url("../../../assets/images/faces/bg_landingpage.svg") no-repeat; background-size: contain;
        .box-owl-carousel{position: relative;
          .owl-carousel{
            .owl-stage{
              .owl-item{height:619px; width:100%;box-shadow: 0px 3px 6px #00000029; border-radius: 40px; overflow: hidden;
                img{
                  &.item-banner{max-width: 100%; height: inherit; max-height: 100%;}
                }
              }
            }
            .owl-dots{position: relative; bottom: 32px; margin-top: auto;
              .owl-dot{ height: 16px; width: 16px;background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #707070; border-radius: 50%; margin-right: 4px;
                &.active{background: #707070 0% 0% no-repeat padding-box; border: 1px solid #707070;}
                &:last-child{margin-right: 0;}
                span{display: none;}
              }
            }
          }
        }
      }
      .box-pc{margin-top: 40px; padding-bottom: 14px;
        .title-pc{color: #343A40; font-size: 24px; font-weight: bold; margin-bottom: 24px;}
        .item-pc-info{ width: calc(100% - 280px); margin-right: 8px; float: left; position: relative;
          .description{color: #333333; font-size: 15px;
            table{max-width: 100% !important;}
            img{max-width: 100% !important; height: auto;}
          }
          .gradient{position: absolute; bottom: 0px;left: 0px;width: 100%; height: 200px; background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));}
          .view-more{letter-spacing: 0px; color: #1A0DAB; font-size: 15px; display: block;cursor:pointer; position: absolute; bottom: 0px; width: 100%;  text-align: center;}
        }
        .item-pc-teacher{width: 268px; background: #fff; padding: 15px; float: left;box-shadow: 0px 1px 2px #00000029; border: 1px solid #EFEFEF; border-radius: 10px;
          .avatar{height: 120px; width: 120px; text-align: center; overflow: hidden; border-radius: 50%; margin: 0 auto;
            img{max-width: 100%; height: auto;}
          }
          .teacher-type{color: #969FAD; font-size: 13px; text-align: center; margin: 8px 0 5px;}
          .teacher-name{color: #4B2D15; font-size: 15px; font-weight: bold; text-align: center; margin-bottom: 15px;}
          .teacher-about{margin-bottom: 15px;color: #333333; text-align: left; font-size: 13px;}
          .button{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #FFD311;border-radius: 5px; color: #23180A; font-size: 14px; height: 40px;  line-height: 40px; text-align: center; width: 100%;
            &.active{background: #FFD311 0% 0% no-repeat padding-box; margin-bottom: 8px;}
          }
        }
      }
    }
  }
}
@media (min-width: 1600px){
  .front-landing-page{
    .content{
      &.front{
        .box-banner{background-position: center;}
      }
    }
  }
}
@media (max-width: 1366px){
}
@media (max-width: 1024px){
}
@media (max-width: 991px){
  .front-landing-page{
    .col-md-12{padding: 0;}
    .navbar{
      .container{width: 750px;}
    }
  }
}
@media (max-width: 768px){
  .front-landing-page{
    .navbar{
      .container{width: 100%;}
    }
    .content{
      &.front{
        .box-banner{
          .box-owl-carousel{position: relative;
            .owl-carousel{
              .owl-stage{
                .owl-item{height: 400px; width:100%;box-shadow: 0px 3px 6px #00000029; border-radius: 40px; overflow: hidden;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 640px){
  .front-landing-page{
    .content{
      &.front{
        .box-pc{
          .item-pc-info{ width: 100%; overflow: auto; max-height: inherit !important;
            .gradient, .view-more{display: none;}
          }
          .item-pc-teacher{width: 100%;
          }
        }
      }
    }
  }
}
@media (max-width: 639px){
  .front-landing-page{
    .content{
      &.front{
        .box-banner{
          .box-owl-carousel{position: relative;
            .owl-carousel{
              .owl-stage{
                .owl-item{height: 250px; width:100%;
                }
              }
            }
          }
        }
        .box-pc{
          .item-pc-info{ width: 100%;
          }
          .item-pc-teacher{width: 100%;
          }
        }
      }
    }
  }
}

@media (max-width: 375px){
}
@media (max-width: 320px){
}
</style>




// WEBPACK FOOTER //
// index.vue?50943814